export default __webpack_public_path__ + "img/46.8234a2.png";